import React from 'react';

import { SxProps, Theme } from '@mui/material';
import Grid from '@mui/material/Grid';

import { IVideoDetails } from '../interfaces';
import { ModalVideoPlayer } from './index';

type TWrapperClass = 'enhanced-video';

interface IProps {
  id?: string;
  videoInfo: IVideoDetails;
  gridOverride?: Partial<{
    xs: number;
    sm: number;
    md: number;
    lg: number;
    style: React.CSSProperties;
    sx: SxProps<Theme>;
  }>;
  wrapperClass?: TWrapperClass;
}

function InlineVideoSection(props: IProps) {
  const [shouldShowVideo, setShouldShowVideo] = React.useState(false);

  const handleOverlayClick = () => {
    setShouldShowVideo(true);
  };

  const {
    videoInfo: { quote, company, companyLogoUrl, name, title, videoUrl, posterUrl, isSelfHosted },
    gridOverride,
    wrapperClass,
  } = props;

  return (
    <Grid
      className={`inline-video-section-container ${wrapperClass ?? ''}`}
      item={true}
      xs={10}
      lg={8}
      data-qa="inline-video-section"
      {...gridOverride}
    >
      <video
        data-video-source-large={videoUrl}
        data-video-source-small={videoUrl}
        loop={true}
        muted
        playsInline
        src={videoUrl}
        autoPlay
        className="inline-video-section-video"
        poster={posterUrl}
      >
        Video Player
      </video>
      <div
        data-qa="inline-video-overlay"
        className="inline-video-overlay"
        onClick={handleOverlayClick}
      >
        <div className="inline-video-quote-box">
          {companyLogoUrl ? (
            <>
              <div className="inline-video-quote-container">
                <div className="inline-video-quote">{quote}</div>
                <div className="inline-video-quote-attribution-name-title">
                  {name}
                  {title ? `, ${title}` : title}
                </div>
              </div>
              <div>
                <img
                  className="inline-video-quote-attribution-company-logo"
                  src={companyLogoUrl}
                  alt="Company Logo"
                />
              </div>
            </>
          ) : (
            <>
              <div className="inline-video-quote">{quote}</div>
              <div className="inline-video-quote-attribution">
                <div className="inline-video-quote-attribution-name">{name}</div>
                <div className="inline-video-quote-attribution-company">{company}</div>
              </div>
            </>
          )}
        </div>
        <div className="inline-video-overlay-watch-button">
          <div className="inline-video-overlay-watch-play-button">{'\u25B6'}</div>
          <div className="inline-video-overlay-watch-button-text"> Watch the video</div>
        </div>
      </div>

      {shouldShowVideo && (
        <ModalVideoPlayer
          videoUrl={videoUrl}
          isSelfHosted={isSelfHosted}
          onClose={() => setShouldShowVideo(false)}
        />
      )}
    </Grid>
  );
}

export { InlineVideoSection };
